import { fabric } from 'fabric';
import {} from '../SwimLaneVertical';
import {} from '../SwimLaneHorizontal';
import { HEADER_CONTAINER } from '../../../utils';

export const editTextSwimLaneVertical = { myText: null, myRect: null, object: null };
export function updateHeaderSwimLaneVertical(e) {
  if (
    !(
      e &&
      e.deselected &&
      (e.deselected[0] === editTextSwimLaneVertical.myText || e.deselected[0] === editTextSwimLaneVertical.myRect)
    )
  )
    return;
  const { object } = editTextSwimLaneVertical;
  if (!object) return;
  window.canvas.remove(editTextSwimLaneVertical.object);
  window.canvas.remove(editTextSwimLaneVertical.myText);
  window.canvas.remove(editTextSwimLaneVertical.myRect);
  const {
    name,
    fontSize,
    fill,
    fontFamily,
    fontWeight,
    fontStyle,
    styles,
    height,
    originX,
    originY,
    textAlign,
    text,
    backgroundColor,
    lockMovementX,
    lockMovementY,
  } = editTextSwimLaneVertical.myText;
  const header = editTextSwimLaneVertical.myRect;
  object.set({
    headerStyle: {
      name: HEADER_CONTAINER,
      stroke: header.stroke,
      strokeWidth: header.strokeWidth,
      fill: header.fill,
      lockMovementX: true,
      lockMovementY: true,
      rx: header.rx,
      ry: header.ry,
    },
    textStyle: {
      name,
      fontSize,
      fill,
      fontFamily,
      fontWeight,
      fontStyle,
      styles,
      height,
      originX,
      originY,
      textAlign,
      text,
      backgroundColor,
      lockMovementX,
      lockMovementY,
    },
    label: editTextSwimLaneVertical.myText.text,
  });
  const myOptions = JSON.parse(JSON.stringify(object));
  const newObj = new fabric.SwimLaneVertical(myOptions);

  window.canvas.add(newObj);
  window.canvas.sendToBack(newObj);
  editTextSwimLaneVertical.object = null;
  editTextSwimLaneVertical.myRect = null;
  editTextSwimLaneVertical.myText = null;
}

export const editTextSwimLaneHorizontal = { myText: null, myRect: null, object: null };
export function updateHeaderSwimLaneHorizontal(e) {
  if (
    !(
      e &&
      e.deselected &&
      (e.deselected[0] === editTextSwimLaneHorizontal.myText || e.deselected[0] === editTextSwimLaneHorizontal.myRect)
    )
  )
    return;
  const { object } = editTextSwimLaneHorizontal;
  if (!object) return;
  window.canvas.remove(editTextSwimLaneHorizontal.object);
  window.canvas.remove(editTextSwimLaneHorizontal.myText);
  window.canvas.remove(editTextSwimLaneHorizontal.myRect);
  const {
    name,
    fontSize,
    fill,
    fontFamily,
    fontWeight,
    fontStyle,
    styles,
    height,
    originX,
    originY,
    textAlign,
    text,
    backgroundColor,
    lockMovementX,
    lockMovementY,
    angle,
  } = editTextSwimLaneHorizontal.myText;
  const header = editTextSwimLaneHorizontal.myRect;
  object.set({
    headerStyle: {
      name: HEADER_CONTAINER,
      stroke: header.stroke,
      strokeWidth: header.strokeWidth,
      fill: header.fill,
      lockMovementX: true,
      lockMovementY: true,
      rx: header.rx,
      ry: header.ry,
    },
    textStyle: {
      name,
      fontSize,
      fill,
      fontFamily,
      fontWeight,
      fontStyle,
      styles,
      height,
      originX,
      originY,
      textAlign,
      text,
      backgroundColor,
      lockMovementX,
      lockMovementY,
      angle,
    },
    label: editTextSwimLaneHorizontal.myText.text,
  });
  const myOptions = JSON.parse(JSON.stringify(object));
  const newObj = new fabric.SwimLaneHorizontal(myOptions);
  window.canvas.add(newObj);
  window.canvas.sendToBack(newObj);
  editTextSwimLaneHorizontal.object = null;
  editTextSwimLaneHorizontal.myRect = null;
  editTextSwimLaneHorizontal.myText = null;
}
